import React , { useState,useEffect }  from 'react';
import {useStripe, useElements, CardElement} from '@stripe/react-stripe-js';
import axios from 'axios';
import $ from "jquery";
import moment from 'moment';

import Showalert from '../common/Showalert';
import CardSection from './CardSection';

import { BaseUrl } from '../common/config';
import Loader from '../common/loader';
import Popup from '../common/popup';


export default function CheckoutForm(props) {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [paymentFailed, setpaymentFailed] = useState(false);
  const [disable, setDisable] = React.useState(false);
  const [viewInfoPayment, setviewInfoPayment] = React.useState(false);
  const [orderPlacedStatus, setorderPlacedStatus] = React.useState(false);
  const [orderErrorMessage, setorderErrorMessage] = useState('');

  let isLoading = false;


  useEffect(() => {
    if (!stripe) {
      return;
    }
  }, [stripe]);
   

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      setDisable(false);
      return;
    }

     event.preventDefault();

     setDisable(true);

     var authdatavalues = JSON.parse(localStorage.getItem('authData'));

      const result = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
        billing_details: {
          // Include any additional collected billing details.
          name: authdatavalues.accountName,
        },
      });

      if(result.error){
        setDisable(false);
      }else{
         setDisable(true);
         stripePaymentMethodHandler(result);
      }

  };

  function stripePaymentMethodHandler(result) {
    if (result.error) {
      // Show error in payment form
      return;
    } else {
      setDisable(true);
      // Otherwise send paymentMethod.id to your server (see Step 4)
      let sumCart = 0;
      let cartData = [];
      if(localStorage.getItem('cartItems'))
      {
        cartData = JSON.parse(localStorage.getItem('cartItems'));
        cartData.map((item)=>{
          sumCart+=(item.PDP_Price1*item.qty);
        });
      }


       var totalAmount = 0;
       var TaxAmount = 0;
       
        if(cartData !=='' && cartData !== null){
            cartData.map((taxItem)=>{
                if(taxItem.productTaxVal > 0){
                  totalAmount += taxItem.PDP_Price1 * taxItem.qty;
                }
            });
        }

        if(totalAmount > 0){ 
          TaxAmount = (totalAmount/100)*20;  
      }
      
      var grandtotal = (TaxAmount > 0 ? sumCart + TaxAmount : sumCart);

      var authData = JSON.parse(localStorage.getItem('authData'));

      // console.log(grandtotal, 'grandtotal');
      // console.log(grandtotal * 100, '(Math.round)');
      // console.log(Math.round(grandtotal * 100), '(Math.round)');

      isLoading = true;
      let payload = JSON.stringify({
        payment_method_id: result.paymentMethod.id,
        amount: Math.round(grandtotal * 100),
        accountCode: authData.accountCode,
      });
      
      setLoading(true);
      var loginDetails = {};
      if (localStorage.getItem('authData')) {
          loginDetails = JSON.parse(localStorage.getItem('authData'));
      }

      let URL =  BaseUrl+"pay";
      axios.post(URL,payload,{headers: { 'Content-Type': 'application/json',"Auth-Token": loginDetails.token}}).then(async(response)=>{

     // handleServerResponse(response.data.data);

      // console.log(response, 'response');

       const actionConf = response.data.data.requires_action;
       const paymentIntent_id = response.data.data.payment_intent_client_secret;

      if(actionConf === true){

        setShow(false);
        $('.modal-pay').hide();
        setviewInfoPayment(false);
        cardConfirmationStripe(paymentIntent_id);

      }else{
         setShow(false);
         $('.modal-pay').hide();
         setviewInfoPayment(true);
         handleServerResponse(response.data.data);
      }

      isLoading = false;
      setLoading(false);
      //setShow(false);
      // setDisable(false);
      setDisable(true);
      }).catch((err)=>{
        console.log(err, 'error');
        isLoading = false;
        setLoading(false);
      });
    }
  }


  const cardConfirmationStripe = async (paymentIntent_id) => {

    if(paymentIntent_id !== ''){

        setShow(false);
        $('.modal-pay').hide();
        setviewInfoPayment(false);
        
       const { paymentIntent, error } = await stripe.confirmCardPayment(paymentIntent_id);

        // console.log(paymentIntent, 'paymentIntent');
        // console.log(error, 'paymentIntenterror');

      if (paymentIntent !== '' && paymentIntent !== undefined && paymentIntent !== null){

       if (paymentIntent.status === "succeeded"){

           setviewInfoPayment(true);
            setpaymentFailed(false);
           handleServerResponse(paymentIntent);

       }

      }else{

         setpaymentFailed(true);
         setorderErrorMessage(error.message);
      }

    }

  }


  function handleServerResponse(response) {

    if (response.error) {
      // Show error from server on payment form
    } else if (response.requires_action) {
      // Use Stripe.js to handle required card action
      stripe.handleCardAction(response.payment_intent_client_secret).then(handleStripeJsResult);
    } else {

      let cartData = [];
      let sumCart = 0;
      let cartDetails  = JSON.parse(localStorage.getItem('cartItems'));
      var freeItemCheck = 0;

      cartDetails.map((cartItem)=>{
          if(cartItem.product_type === 'Free'){
              freeItemCheck++;
          }
      });

       var totalAmount = 0;
       var TaxAmount = 0;
       
        if(cartDetails !=='' && cartDetails !== null){
            cartDetails.map((taxItem)=>{
                if(taxItem.productTaxVal > 0){
                  totalAmount += taxItem.PDP_Price1 * taxItem.qty;
                }
            });
        }

      if(totalAmount > 0){ 
          TaxAmount = (totalAmount/100)*20;  
      }
        
      if(localStorage.getItem('cartItems') && freeItemCheck === 0){

        cartData = JSON.parse(localStorage.getItem('cartItems'));
        cartData.map((item)=>{
          sumCart+=(item.PDP_Price1*item.qty);
        });
      
      }else{
      
        cartData = JSON.parse(localStorage.getItem('cartItemsNew'));
        cartData.map((item)=>{
          sumCart+=(item.PDP_Price1*item.qty);
        });
      
      }

      let DeliveryData = {};
      if(localStorage.getItem('DeliveryData'))
      {
        DeliveryData = JSON.parse(localStorage.getItem('DeliveryData'));
      }
      
      let authData = {};
      if(localStorage.getItem('authData'))
      {
        authData = JSON.parse(localStorage.getItem('authData'));
      }

      isLoading = true;

      var grandtotal = (TaxAmount > 0 ? sumCart + TaxAmount : sumCart);

      let payload = JSON.stringify({
        amount: Math.round(sumCart)*100,
        subtotal: sumCart.toFixed(2),
        grandtotal: grandtotal.toFixed(2),
        cartData: cartData,
        DeliveryData: moment(DeliveryData.deliveryDate).format("DD-MM-YYYY"),        
        authData: authData,
        PaymentMethod: 'K',
        tax_percentage: (TaxAmount > 0 ? '20' : 0),
        taxable_amount: totalAmount,
        tax_amount: TaxAmount.toFixed(2),
      });
      
      let URL =  BaseUrl+"order";
      isLoading = true;
      setLoading(true);
      var numberOfAjaxCAllPending = 0;
      var timeInterval = '2000';
      var timeInterval1 = '2000';
      var current = this;
      var orderId = '';

      var loginDetails = {};
      if (localStorage.getItem('authData')) {
          loginDetails = JSON.parse(localStorage.getItem('authData'));
      }

      axios.post(URL, payload, {headers: { 'Content-Type': 'application/json', "Auth-Token": loginDetails.token}}).then(async(response)=>{
        numberOfAjaxCAllPending++;
        localStorage.removeItem('cartItems');
        localStorage.setItem('orderId',response.data.data.orderId);
        orderId = response.data.data.orderId;
        if(response.data.data.orderId !==''){
          setorderPlacedStatus(true);
          var myDate = new Date();
          var year = myDate.getFullYear();
          var month = myDate.getMonth() + 1;
          if(month <= 9)
          month = '0'+month;
          var day= myDate.getDate();
          if(day <= 9)
          day = '0'+day;
          var prettyDate = day +'/'+ month +'/'+ year +' ' + myDate.getHours() + ":"  
                + myDate.getMinutes();
          localStorage.setItem('order_placed_date', prettyDate);
          localStorage.setItem('delivery_date', moment(DeliveryData.deliveryDate).format("DD/MM/YYYY"));
        }
        isLoading = false;
        setLoading(false);
        setShow(false);
        clearInterval(myInterval);
           setDisable(true);
        }).catch((err)=>{
        numberOfAjaxCAllPending++;
        isLoading = false;
        setLoading(false); 
        setShow(false);
        return err;
      });

      var myInterval = setInterval(function() {
      if(numberOfAjaxCAllPending == 0){
        numberOfAjaxCAllPending++;
        setShow(true);
        if(show === false){
        $('.modal-pay').hide();
        }
        timeInterval = '';
      }},timeInterval);

      var myInterval1 = setInterval(function() {
        setShow(false);
        setorderPlacedStatus(true);
         $('.modal-pay').hide();
         timeInterval1 = '';
         orderSuccess(orderId);
      },timeInterval1);

    }
  }
  
  function handleStripeJsResult(result) {
    if (result.error) {
      // Show error in payment form

    } else {
      // The card action has been handled
      // The PaymentIntent can be confirmed again on the server
      let payload = JSON.stringify({
        payment_intent_id: result.paymentIntent.id
      })
      let URL =  BaseUrl+"pay";
      isLoading = true;
      setLoading(true);

      var loginDetails = {};
      if (localStorage.getItem('authData')) {
          loginDetails = JSON.parse(localStorage.getItem('authData'));
      }   

      axios.post(URL,payload,{headers: { 'Content-Type': 'application/json', "Auth-Token": loginDetails.token}}).then(async(response)=>{
      handleServerResponse(response.data.data);
      isLoading = false;
      setLoading(false);
      }).catch((err)=>{
        console.log(err);
        isLoading = false;
        setLoading(false);
        setviewInfoPayment(false);
      });
    }
  }


  function orderSuccess(orderId){
    setShow(false);
    if(orderId !==''){
      window.location.href = '/thankyou';
    }
  }
    
  function closePopup()
  {
    window.location.href= '/checkoutpay';
  }


  return (<div>
    {show == true && <Showalert title='oops!' message="The Server is busy, please try after sometime or contact us to place your order" />
    }

    {paymentFailed == true && <Showalert title='Payment Failed' message={orderErrorMessage}
      //message="Error code: 1004 Oops! Unable to process your order. Please try again" 
    />
    }

    {viewInfoPayment === true && 

            <Popup
             extClass="info-poup payment-popup show"
             headMoreTxt={
             <>
                <div className="order-top">
                    <h4>We Are Processing Your Order</h4>
                </div>
             </>
             }
             bodyMoreTxt={
             <>
                <div className="info-bdy">
                    <div className='order-progress-wrap'>
                        <ul className='odr-progress-list'>
                        <li>
                         <span className='progress-status'></span>
                         <h4>Processing</h4>
                         <p>Validating Card Information.</p>
                        </li>
                        <li>
                          <span className='progress-status'></span>
                          <h4>Processing</h4>
                          <p>Placing your order now.</p>
                        </li>
                       <li> 
                         <span className={orderPlacedStatus === true ?  'progress-status' : 'progress-status progess-load'} ></span>
                         <h4>Processing</h4>
                         <p>Completing your online payment.</p>
                       </li>
                      </ul>
                    </div>
                </div>
            </>
             }
             />

      }

    <div className="modal-pay">
      <div className="pay-popup">
        <div className="pay-inner" >
          {props.closeBTN}
        {/* <span className="popup-close" onClick={(e)=>closePopup(e)}></span> */}
          <form onSubmit={handleSubmit}>
            {/* <span style="color:red;">{errMsg}</span> */}
            {/* {isLoading && <Loader  propsClassName="load-lag"  /> } */}
            <CardSection />
            {loading && <Loader  /> }
            {!loading && <button type="submit"  id='button_stripe' disabled={disable}>
              Submit Payment
            </button> }
          </form>
        </div>
      </div>
      <div className="modal-overly"></div>
    </div>
    </div>
  );
}